// extracted by mini-css-extract-plugin
export default {"wrap":"kH-z","articleImagesWrap":"lH-z","articleImage":"mH-z","singleImage":"nH-z"};